module.exports = __webpack_public_path__ + "static/img/18f9617e87a30100030c3f0f4fe99299.88a818d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/18f9617e87a30100030c3f0f4fe99299.jpg
// module id = 4VIG
// module chunks = 4